import PropTypes from 'prop-types';
import { BsBuilding, BsCpu, BsFunnel, BsGeoAlt, BsPeopleFill, BsSearch } from 'react-icons/bs';

import Tag from '#globalComponents/Tag/Tag';

import { contactModeLabel } from '../../constants/conversation';

const locationLabel = (location, radius) =>
	location.type === 'city' && radius ? `${location.name} · ${radius} km` : location.name;

/**
 * What the assistant understood, as one row of chips inside a plan message.
 */
const ProfileChips = ({ profile, mandate }) => (
	<div className="flex flex-wrap gap-1.5">
		{(profile?.terms ?? []).map((term) => (
			<span
				key={term}
				className="inline-flex items-center gap-1 rounded-control border border-primary-200 bg-primary-100 px-2 py-1 text-xs text-primary-700"
			>
				<BsSearch className="h-3 w-3" />
				{term}
			</span>
		))}
		{(profile?.locations ?? []).map((location) => (
			<span
				key={`${location.type}-${location.name}`}
				className="inline-flex items-center gap-1 rounded-control border border-bgBase-500 bg-bgBase-300 px-2 py-1 text-xs text-text"
			>
				{location.type === 'bundesland' ? <BsBuilding className="h-3 w-3" /> : <BsGeoAlt className="h-3 w-3" />}
				{locationLabel(location, profile?.radius)}
			</span>
		))}
		{profile?.employeesFrom && (
			<span className="inline-flex items-center gap-1 rounded-control border border-success-500/40 bg-success-200 px-2 py-1 text-xs text-success-700">
				<BsFunnel className="h-3 w-3" />≥ {profile.employeesFrom} Mitarbeiter · Filter
			</span>
		)}
		{(profile?.criteria ?? []).map((criterion) => (
			<span
				key={criterion}
				className="inline-flex items-center gap-1 rounded-control border border-primary-200 bg-white px-2 py-1 text-xs text-primary-700"
			>
				<BsCpu className="h-3 w-3" />
				{criterion}
			</span>
		))}
		{mandate && <Tag label={`max. ${mandate.companyLimit} Firmen`} tone="neutral" />}
		{mandate && (
			<span className="inline-flex items-center gap-1 rounded-full bg-bgBase-400 px-2 py-0.5 text-xs text-bgBase-800">
				<BsPeopleFill className="h-3 w-3" />
				{contactModeLabel(mandate.contacts?.mode, 'short')}
			</span>
		)}
	</div>
);

ProfileChips.propTypes = {
	profile: PropTypes.object,
	mandate: PropTypes.object,
};

export default ProfileChips;
